"use client";

import { useState, useEffect } from "react";
import {
  barLevelsStill,
  barLevels,
  barFrameMs,
  settleLevels,
} from "./softmax-curve";
import { useReducedMotion } from "../use-reduced-motion";

export function useStepBadge({
  done,
  landing,
}: Readonly<{ done: boolean; landing: boolean }>) {
  const reduced = useReducedMotion();
  const [frame, setFrame] = useState(0);
  const [transition, setTransition] = useState<
    Readonly<{
      done: boolean;
      from: readonly number[];
      step: number | null;
    }>
  >({ done, from: barLevelsStill, step: null });

  if (done !== transition.done) {
    setTransition({
      done,
      from: barLevels(frame),
      step: done && landing && !reduced ? 0 : null,
    });
  }

  useEffect(() => {
    if (done || reduced) return;

    const id = window.setInterval(
      () => setFrame((current) => current + 1),
      barFrameMs,
    );
    return () => window.clearInterval(id);
  }, [done, reduced]);
  const settling = transition.step !== null;
  useEffect(() => {
    if (!settling) return;

    const id = window.setInterval(() => {
      setTransition((current) => ({
        ...current,
        step:
          current.step === null || current.step >= 2 ? null : current.step + 1,
      }));
    }, barFrameMs);
    return () => window.clearInterval(id);
  }, [settling]);
  let levels: readonly number[] | null = null;

  if (!done) levels = reduced ? barLevelsStill : barLevels(frame);
  else if (transition.step !== null)
    levels = settleLevels({ from: transition.from, step: transition.step });

  return { levels, reduced, settling };
}
